<template>
  <div class="skiplink">
    <a href="#content-wrapper"> Ga direct naar de inhoud </a>
  </div>
</template>
